var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.swiperOption)?_c('swiper',{ref:"postMoreSwiper",staticClass:"more-swiper-container",attrs:{"options":_vm.swiperOption}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }